module.exports = __webpack_public_path__ + "img/hecho-en-mexico.b1c94d12.png";